import { TypeaheadSelectInputOption } from '@/components/form/baseInputs/inputTypes';
import { DocumentType } from '@/types/schema';

import { isWillDocumentType } from '../../ManageDocumentAmendments/utils/ManageDocumentAmendments.utils';

const INCORPORATE_SUBTEXT: Partial<Record<DocumentType, string>> = {
  [DocumentType.SignedTrustDocument]:
    'Summary will incorporate details from trusts, amendments, and related documents',
  [DocumentType.TrustAmendment]:
    'Summary will incorporate details from trusts, amendments, and related documents',
  [DocumentType.TrustRelatedDocument]:
    'Summary will incorporate details from trusts, amendments, and related documents',
  [DocumentType.Will]:
    'Summary will incorporate details from wills and codicils',
  [DocumentType.WillCodicil]:
    'Summary will incorporate details from wills and codicils',
  [DocumentType.LlcAgreement]:
    'Summary will incorporate details from LLC agreements and amendments',
  [DocumentType.LlcAgreementAmendment]:
    'Summary will incorporate details from LLC agreements and amendments',
  [DocumentType.OperatingAgreement]:
    'Summary will incorporate details from operating agreements and amendments',
  [DocumentType.OperatingAgreementAmendment]:
    'Summary will incorporate details from operating agreements and amendments',
  [DocumentType.PartnershipAgreement]:
    'Summary will incorporate details from partnership agreements and amendments',
  [DocumentType.PartnershipAgreementAmendment]:
    'Summary will incorporate details from partnership agreements and amendments',
};

export function getIncorporateDocumentsLabel(
  documentType: DocumentType
): string {
  if (isWillDocumentType(documentType)) {
    return 'Incorporate details from codicils';
  }
  if (
    documentType === DocumentType.SignedTrustDocument ||
    documentType === DocumentType.TrustAmendment ||
    documentType === DocumentType.TrustRelatedDocument
  ) {
    return 'Incorporate details from amendments and related documents';
  }
  return 'Incorporate details from amendments';
}

export function getIncorporateDocumentsSubtext(
  documentType: DocumentType
): string {
  return INCORPORATE_SUBTEXT[documentType] ?? '';
}

export function getDefaultSummaryNameForPrompt(
  promptOptions: TypeaheadSelectInputOption<string>[],
  summaryPromptId: string
): string {
  return (
    promptOptions.find((promptOption) => promptOption.value === summaryPromptId)
      ?.display ?? ''
  );
}
